import moment from "moment-timezone";
import { getCryptoTime, getTimes, getUsTimes, todayIsHoliday } from "./time";
import { US } from "utils/constant/ITME_INFO";
import { dailyQueries, realtimeQueries } from "data/mysql/queries/page";
import { detailRealtimeQueries } from "data/mysql/queries/detail";

// 데이터 덮어쓰기 함수
export const updatePrices = (origin: any, additionalData: any, config?: any) => {
    if (!additionalData || additionalData.length === 0) return origin;

    // let origin = { ...data };

    // 기본 가격 덮어쓰기
    origin.ADJ_CLOSE = additionalData.CUR_PRICE;
    origin.ADJ_CLOSE_USD = additionalData.CUR_PRICE_USD;
    origin.ADJ_CLOSE_KRW = additionalData.CUR_PRICE_KRW;

    // 가격 등락률 덮어쓰기 (선택적)
    if (config?.includeChanges) {
        origin.ADJ_CLOSE_CHG = additionalData.PRICE_CHG_PER;
        origin.ADJ_CLOSE_CHANGE = (origin.LOC === "Korea (South)") ? additionalData.PRICE_CHG_KRW : additionalData.PRICE_CHG_USD;
    }

    // 추가 정보 덮어쓰기
    if (config?.addedUpdated) {
        origin = config.addedUpdated(origin, additionalData);
    }
    return origin;
}


// 한(미X)크 혼합 데이터 아이템 코드 추출
export const realtimeMixItemCodes = async (origin: any) => {

    let result = [...origin];

    const NotKoreanMarketOpenTime = await isNotKoreanMarketOpenTime();

    const itemCodes: string[] = result
        .filter((re: any) => {
            if (re.USE_YN_5MIN) {
                if (isKoreanStock(re.LOC) && (NotKoreanMarketOpenTime)) {
                    return false;
                }
                if (re.LOC === US) return false;
                return true;
            }
            return false;
        })
        .map((filteredResult: any) => filteredResult.ITEM_CD_DL);
    let itemCodesString = ''
    if (itemCodes.length > 0) {
        itemCodesString = itemCodes.map((code: string) => `'${code}'`).join(', ');
    }

    return [itemCodes, itemCodesString];
}





// 한국 장시간 아닐 경우 true
export const isNotKoreanMarketOpenTime = async () => {
    const { now, marketOpen, marketClose } = await getTimes();
    if (now.isBefore(marketOpen) || now.isAfter(marketClose)) {
        // console.log('한국시간 15시 50분 이후 또는 9시 5분 이전')
        return true;
    }
    return false;
}

// 한국 전략 5분 데이터 조회 가능 여부
export const isKoreanStrategy5minTime = async () => {
    const { now, marketOpen, koreaStrategy5minClose } = await getTimes();
    if (now.isBefore(marketOpen) || now.isAfter(koreaStrategy5minClose)) {
        return true;
    }
    return false;
}

// 미사용
export const isKoreanRiskBatchTime = async () => {
    const { now, marketClose, priceBatch } = await getTimes();
    if (now.isSameOrAfter(priceBatch) && now.isBefore(marketClose)) {
        // console.log('한국시간 15시 35분 ~ 15시 50분')
        return true;
    }
    else {
        return false;
    }
}

export const isCryptoRiskBatchTime = () => {
    const { now, cryptoRiskBatch, cryptoOpen } = getCryptoTime();
    if (now.isSameOrAfter(cryptoOpen) && now.isBefore(cryptoRiskBatch)) {
        // console.log('한국시간 9시~10시 10분')
        return true;
    }
    else {
        return false;
    }
}

export const isKBKoreaTradingTime = async () => {
    const { now, kbKoreaOrderClose, kbKoreaOrderOpen } = await getTimes();

    if (now.isSameOrAfter(kbKoreaOrderOpen) && now.isBefore(kbKoreaOrderClose)) {
        return true;
    }
    else {
        return false;
    }
}

export const isKBKoreaCantReserveTime = async () => {

    const { now, kbKoreaReserveOpen, kbKoreaOrderClose } = await getTimes();

    if (now.isSameOrAfter(kbKoreaOrderClose) && now.isBefore(kbKoreaReserveOpen)) {
        return true;
    }
    else {
        return false;
    }

}

export const isKBUsTradingTime = async () => {
    const { now, kbUsPremarketOpen, kbUsAfterMarketClose } = await getUsTimes();

    if (now.isSameOrAfter(kbUsPremarketOpen) && now.isBefore(kbUsAfterMarketClose)) {
        return true;
    }
    else {
        return false;
    }
    // // 현재 시간이 정규 거래 시간 내에 있는지 확인
    // return now.isBetween(marketOpenTime, marketCloseTime, 'minute', '[)');
}

export const isKBUsAfterMarketTime = async () => {
    const { now, kbUsStanardOrderClose, kbUsAfterMarketClose } = await getUsTimes();
    if (now.isSameOrAfter(kbUsStanardOrderClose) && now.isBefore(kbUsAfterMarketClose)) {
        return true;
    }
    else {
        return false;
    }
}

export const isKBUsPreMarketTime = async () => {
    const { now, kbUsStanardOrderOpen, kbUsPremarketOpen } = await getUsTimes();
    if (now.isSameOrAfter(kbUsPremarketOpen) && now.isBefore(kbUsStanardOrderOpen)) {
        return true;
    }
    else {
        return false;
    }
}

export const isKBUsStanardOrderTime = async () => {
    const { now, kbUsStanardOrderOpen, kbUsStanardOrderClose } = await getUsTimes();
    if (now.isSameOrAfter(kbUsStanardOrderOpen) && now.isBefore(kbUsStanardOrderClose)) {
        return true;
    }
    else {
        return false;
    }
}
export const isKBUsStanardBatchTime = async () => {
    const { now, kbUsStanardOrderOpen, kbUsStandardBathClose, kbUsStanardOrderClose } = await getUsTimes();
    if (now.isSameOrAfter(kbUsStanardOrderClose) && now.isBefore(kbUsStandardBathClose)) {
        return true;
    }
    else {
        return false;
    }
}

export const isKoreanStock = (loc: string) => {
    return loc === "Korea (South)";
}